<template>
  <div class="mt-3">
    <div
      v-if="images && images.length"
      class="my-gallery flex flex-wrap w-full"
      itemscope
      itemtype="http://schema.org/ImageGallery"
    >
      <GalleryItem
        v-for="image in images"
        :key="image.src"
        id="gallery-item"
        :src="getImgUrl(image.src)"
        class="pr-3 mt-3"
        :thumbnail="getImgUrl(image.thumbnail)"
        :altText="image.altText"
        :description="image.description"
        :resolution="`${image.w}x${image.h}`"
      />
    </div>
    <div
      v-else
      class="my-gallery flex flex-wrap w-full"
      itemscope
      itemtype="http://schema.org/ImageGallery"
    >
      <GalleryItem
        :key="image.src"
        v-if="single == true"
        :src="getImgUrl(image.src)"
        :thumbnail="getImgUrl(image.thumbnail)"
        :altText="image.altText"
        :description="image.description"
        :resolution="`${image.w}x${image.h}`"
      />
    </div>
    <Photoswipe />
  </div>
</template>

<script>
import GalleryItem from './GalleryItem.vue'
import Photoswipe from './Photoswipe.vue'

export default {
  name: 'ImageGallery',
  components: {
    GalleryItem,
    Photoswipe,
  },
  props: {
    images: Array,
    image: Object,
    single: Boolean,
  },
  methods: {
    getImgUrl(img) {
      return require(`../assets/${img}`)
    },
  },
}
</script>
<style scoped>
#gallery-item {
  flex: 0 50%;
}
@screen lg {
  #gallery-item {
    flex: 0 0 33.333333%;
  }
}
</style>
